export function formatLastSeen(value: string | null) {
  if (!value) return "Brak kontaktu";
  const elapsedMinutes = Math.max(
    0,
    Math.floor((Date.now() - new Date(value).getTime()) / 60_000),
  );
  if (elapsedMinutes < 2) return "Przed chwilą";
  if (elapsedMinutes < 60) return `${elapsedMinutes} min temu`;
  if (elapsedMinutes < 24 * 60) {
    return `${Math.floor(elapsedMinutes / 60)} godz. temu`;
  }
  return new Intl.DateTimeFormat("pl-PL", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(value));
}

const polishNameVocatives: Readonly<Record<string, string>> = {
  adam: "Adamie",
  agnieszka: "Agnieszko",
  aleksandra: "Aleksandro",
  alicja: "Alicjo",
  andrzej: "Andrzeju",
  anna: "Anno",
  barbara: "Barbaro",
  bartosz: "Bartoszu",
  beata: "Beato",
  damian: "Damianie",
  daniel: "Danielu",
  dorota: "Doroto",
  elżbieta: "Elżbieto",
  emilia: "Emilio",
  ewa: "Ewo",
  grzegorz: "Grzegorzu",
  izabela: "Izabelo",
  iwona: "Iwono",
  jakub: "Jakubie",
  jan: "Janie",
  joanna: "Joanno",
  julia: "Julio",
  kamil: "Kamilu",
  kamila: "Kamilo",
  karolina: "Karolino",
  katarzyna: "Katarzyno",
  kinga: "Kingo",
  krzysztof: "Krzysztofie",
  łukasz: "Łukaszu",
  maciej: "Macieju",
  magdalena: "Magdaleno",
  małgorzata: "Małgorzato",
  marcin: "Marcinie",
  marek: "Marku",
  maria: "Mario",
  marta: "Marto",
  mateusz: "Mateuszu",
  michal: "Michale",
  michał: "Michale",
  monika: "Moniko",
  natalia: "Natalio",
  oliwia: "Oliwio",
  patrycja: "Patrycjo",
  paulina: "Paulino",
  paweł: "Pawle",
  piotr: "Piotrze",
  rafał: "Rafale",
  robert: "Robercie",
  sebastian: "Sebastianie",
  tomasz: "Tomaszu",
  weronika: "Weroniko",
  wiktoria: "Wiktorio",
  wojciech: "Wojciechu",
  zofia: "Zofio",
};

export function formatPolishGreeting(displayName: string | null | undefined) {
  const firstName = displayName?.trim().split(/\s+/u)[0];
  if (!firstName) return "Dzień dobry";

  const vocative =
    polishNameVocatives[firstName.toLocaleLowerCase("pl-PL")] ?? firstName;
  return `Dzień dobry, ${vocative}`;
}

export function downloadBrowserFile({
  blob,
  filename,
}: {
  blob: Blob;
  filename: string;
}) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
